export default __webpack_public_path__ + "static/media/Twitter.f207829e.svg";